module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-26.5f1ea668.jpg";